import { UserId, UserLike } from '@/shared/models/User';
import { Url } from '@/shared/models/common';
import ChatMentionTarget from './ChatMentionTarget';

export default class ChatUser extends ChatMentionTarget<UserId> implements UserLike {
  avatar: Url | null = null;

  static withName(name: string): ChatUser {
    const user = new ChatUser();
    user.name = name;
    return user;
  }

  get fullName(): string {
    return this.description;
  }

  set fullName(name: string) {
    this.description = name;
  }

  get typeName(): string {
    return 'user';
  }
}
